export default __webpack_public_path__ + "static/media/marker_success.9cb37c42.png";